import { sendEventDataAPI } from '../../api'
import { getUrlParams } from './common'

export default async function sendEventData(payload) {
  try {
    const storedParams = JSON.parse(
      localStorage.getItem('query_params') || '{}',
    )
    const urlParams = getUrlParams()

    // UTM parameters to capture
    const paramsToCapture = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
    ]

    const params = paramsToCapture.reduce((acc, param) => {
      acc[param] = urlParams[param] || storedParams[param] || ''
      return acc
    }, {})

    if (process.env.REACT_APP_ENV === 'production' && payload?.lead_id) {
      console.log('sendEventData -> Capture lead: ->', payload.lead_id)
      const iframe = document.createElement('iframe')
      iframe.src = `https://track.vcommission.com/pixel?av=681072af711f1d0889326dc2&txn_id=${payload.lead_id}&sub1=${payload.lead_id}`
      iframe.width = '1'
      iframe.height = '1'
      iframe.frameBorder = '0'
      iframe.scrolling = 'no'
      iframe.style.border = '0'
      iframe.style.display = 'none'
      iframe.setAttribute('loading', 'eager')
      iframe.setAttribute('aria-hidden', 'true')
      iframe.setAttribute('tabIndex', '-1')
      document.body.appendChild(iframe)
    }

    console.log('sendEventData -> Sent event data: ->', payload)
    await sendEventDataAPI({ ...payload, ...params })
  } catch (error) {
    console.log('Error while sending event tracking data', error, payload)
  }
}
